import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { NavLink } from 'react-router-dom';

import {
  useAppSelector,
  useAppDispatch,
} from '../../app/hooks';
import {
  selectTenants,
} from '../tenant/tenantSlice';
import {
  selectAuthStatus,
} from '../auth/authSlice';
import {
  selectCurrentTenant,
  switchTenantAction,
} from '../user/userSlice';
import { route_path, push } from '../../app/route';

export function TopBar() {
  const dispatch = useAppDispatch();
  const auth_status = useAppSelector(selectAuthStatus);
  let tenants = useAppSelector(selectTenants);
  let current_tenant = useAppSelector(selectCurrentTenant);

  const switchTenant = (tenant_id: string) => {
    dispatch(switchTenantAction(tenant_id));
  };
  const createTenant = () => {
    dispatch(push(route_path.tenant_create));
  };
  let home_uri = '/login';
  if (auth_status === 'login') {
    home_uri = `/tenants/${current_tenant?.name}/home`
  }
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-danger">
      <div className="container-fluid">
        <NavLink className="navbar-brand" to={home_uri}>
          Auth Portal
        </NavLink>
        {tenants.length ? 
          <div className="d-flex">
            <DropdownButton title={current_tenant?.title ?? current_tenant?.tenant_id ?? 'loading'} variant="danger">
              {tenants.map((tenant) => {
                return (
                  <Dropdown.Item
                    onClick={() => switchTenant(tenant.tenant_id)}
                    key={tenant.tenant_id}>
                    {tenant.title ?? tenant.tenant_id}
                  </Dropdown.Item>
                );
              })}
              <Dropdown.Divider />
              <Dropdown.Item onClick={(e) => createTenant()}>
                Create Tenant
              </Dropdown.Item>
            </DropdownButton>
          </div>
          : null }
      </div>
    </nav>
  );
}
